module.exports = __webpack_public_path__ + "static/yanran_ding-9b971e494422240a821adf6aa1735710.jpg";